/*
 * Feature flags for the metrics pages.
 *
 * One place, so turning something back on is a one-line change rather than a
 * hunt through four files.
 */

/**
 * Anything that ranks named people or organisations against each other.
 *
 * Off for now. The code is left in place and still computed — the server keeps
 * returning `leaderboards` and `rankings` — so restoring these is flipping this
 * to true, not rebuilding them.
 *
 * What this hides:
 *   - Manager page: "Most improved" and "Highest current scores" (people)
 *   - Admin Portfolio: "Highest adoption", "Most improvement", "Most intensive use" (orgs)
 *   - Admin Efficacy: "Which organisations are moving" (orgs, ranked worst first)
 *
 * What it deliberately does NOT hide, because these are inventories rather than
 * rankings — they list everyone rather than picking winners, and the pages have
 * no purpose without them:
 *   - the people table on the manager page
 *   - the book-of-business table on the admin portfolio
 *   - the attention list, which flags a threshold rather than a position
 *   - content difficulty, which ranks MATERIAL, not people
 */
export const SHOW_LEADERBOARDS = false;
